import './Breadcrumbs.ae3c14a7640646ffa1639012fa5b61cf.css';
export default {"breadcrumbs":"_breadcrumbs_rfkzb_1","breadcrumb":"_breadcrumb_rfkzb_1","forwardIcon":"_forwardIcon_rfkzb_1"};